module.exports = __webpack_public_path__ + "static/media/italic.a78dec23.png";